"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecommendationStringEnum = void 0;
var RecommendationStringEnum;
(function (RecommendationStringEnum) {
    RecommendationStringEnum["FINE"] = "Fine";
    RecommendationStringEnum["BLACKLISTED"] = "Blacklisted";
})(RecommendationStringEnum || (exports.RecommendationStringEnum = RecommendationStringEnum = {}));
